import billio from "../assets/billio-logo.png";

const assets = {
  billio,
};

export default assets;
